<div class="popover">
  <div class="popover__head">
    <h3 class="popover__title">Informações do campo</h3>
    <button type="button" class="popover__close" aria-label="Fechar" (click)="closed.emit()">×</button>
  </div>

  @if (info.description) {
    <p class="popover__desc">{{ info.description }}</p>
  }

  <div class="popover__section-title">Detalhes técnicos</div>

  <dl class="popover__details">
    <dt>Label</dt>
    <dd>{{ info.label }}</dd>

    <dt>Atributo</dt>
    <dd><code>{{ info.attribute }}</code></dd>

    <dt>Tabela</dt>
    <dd><code>{{ info.table }}</code></dd>

    @if (info.view !== undefined) {
      <dt>Visão</dt>
      <dd>{{ info.view }}</dd>
    }

    <dt>Tipo de Atributo</dt>
    <dd>{{ info.type }}</dd>
  </dl>
</div>
